// extracted by mini-css-extract-plugin
export default {"asterisk":"asterisk__zNQbaW","confirmButton":"confirmButton__uucbTe"};